import {
  DotsThreeVertical,
  PencilSimpleLine,
  Trash,
} from "@phosphor-icons/react";
import { useState } from "react";

import RenderIf from "common/components/RenderIf";
import { Button, type ButtonVariantType } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import FlowActionsDialog from "./FlowActionsDialog";

import type { CampaignFlow } from "../../../../../types";

interface FlowActionsProps {
  flow: CampaignFlow;
  variant: ButtonVariantType;
  deleteFlow?: (flowId: string) => void;
}

export default function FlowActions({
  flow,
  variant,
  deleteFlow = null,
}: FlowActionsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useTwBreakpoint("lg");
  const [selectedActionType, setSelectedActionType] = useState<
    "delete" | "edit"
  >();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="ml-auto" asChild>
          <Button
            size={isDesktop ? "md" : "lg"}
            intent="iconOnly"
            variant={variant}
          >
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuList>
            <DropdownMenuItem
              onClick={() => {
                setIsOpen(true);
                setSelectedActionType("edit");
              }}
            >
              <PencilSimpleLine /> Edit name
            </DropdownMenuItem>
            <RenderIf condition={!!deleteFlow}>
              <DropdownMenuItem
                variant="danger"
                onClick={() => {
                  setIsOpen(true);
                  setSelectedActionType("delete");
                }}
              >
                <Trash /> Delete flow
              </DropdownMenuItem>
            </RenderIf>
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>

      <FlowActionsDialog
        flow={flow}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type={selectedActionType}
        deleteFlow={deleteFlow}
      />
    </>
  );
}
